<template>
  <header :class="['site-header', { overlay: isMapRoute }]">
    <div class="header-inner container">
      <div class="brand">
        <!-- подсветка для домашней страницы -->
        <BaseButton to="/" :class="['nav-btn', { 'active-full': isActive('home') }]" aria-current="page">CT-map</BaseButton>
      </div>

      <nav class="header-actions">
        <!-- подсветка для страницы карты -->
        <BaseButton to="/map" :class="['nav-btn', { 'active-full': isActive('map') }]">Карта</BaseButton>

        <!-- кнопка О проекте -->
        <BaseButton to="/about" :class="['nav-btn', { 'active-full': isActive('about') }]">О проекте</BaseButton>

        <!-- если в будущем захочешь здесь ещё ссылки — добавляй аналогично:
             <BaseButton to="/life" :class="['nav-btn', { 'active-full': isActive('life') }]">Науки о Жизни</BaseButton>
        -->
      </nav>
    </div>
  </header>
</template>

<script>
import BaseButton from '@/components/ui/BaseButton.vue'
export default {
  name: 'Header',
  components: { BaseButton },
  computed: {
    // Меняем условие под то, как вы называете маршрут карты
    isMapRoute() {
      return this.$route && (this.$route.name === 'map' || this.$route.path === '/map')
    }
  },
  methods: {
    // Универсальная проверка: принимает имя маршрута (string) или путь (начинается с '/')
    // Возвращает true если текущий маршрут соответствует указанному.
    isActive(routeOrPath) {
      if (!this.$route) return false
      // если передали путь
      if (typeof routeOrPath === 'string' && routeOrPath.startsWith('/')) {
        return this.$route.path === routeOrPath
      }
      // иначе сравниваем по имени маршрута
      if (typeof routeOrPath === 'string') {
        return this.$route.name === routeOrPath
      }
      return false
    }
  }
}
</script>

<style scoped>
.site-header { position: static; z-index: 1200; background: transparent; padding: 12px 0; pointer-events: auto; }
.site-header.overlay { position: absolute; top: 0; left: 0; right: 0; background: transparent; z-index: 1400; pointer-events: none; }
.site-header.overlay .header-inner { pointer-events: auto; max-width: none; width: 100%; padding: 0 25px; box-sizing: border-box; display: flex; align-items: center; justify-content: space-between; }
.header-inner { max-width: 1500px; margin: 0 auto; padding: 0 20px; display:flex; align-items:center; justify-content:space-between; gap: 16px; box-sizing: border-box; }
.brand { flex: 0 0 auto; }
.header-actions { display:flex; gap:10px; align-items:center; flex: 0 0 auto; }

/* Плавный переход для background/color когда кнопки активируются */
.nav-btn {
  transition: background .14s ease, color .14s ease, border-color .14s ease;
}

/* используем ту же визуальную тему, что и раньше */
.header-actions .nav-btn.active-full {
  background: #222222;
  color: #fff;
  border-color: #222222;
}
</style>
